import React from 'react';
import { useTranslation } from 'react-i18next';
import { Nav } from 'react-bootstrap';

import './languageSwitcherComponent.css';

// Temporary language toggle for verifying the i18n setup while the bulk
// migration is in progress. The label shows the language you would switch
// TO: "In English" while the app is in Finnish, "Suomeksi" while in English.
// changeLanguage() persists the choice to localStorage (see src/i18n.js).
//
// Two variants:
//  - inline: a Nav.Link inside the header navbar, styled by Bootstrap
//  - default: a floating chip for auth screens, which have no navbar
const LanguageSwitcherComponent = ({ inline = false }) => {
    const { i18n } = useTranslation();

    const current = i18n.resolvedLanguage || i18n.language;
    const label = current === 'fi' ? 'In English' : 'Suomeksi';

    const handleToggle = () =>
        i18n.changeLanguage(current === 'fi' ? 'en' : 'fi');

    if (inline) {
        return (
            <Nav.Link
                href="#"
                onClick={(event) => {
                    event.preventDefault();
                    handleToggle();
                }}
            >
                {label}
            </Nav.Link>
        );
    }

    return (
        <button type="button" className="language-switcher" onClick={handleToggle}>
            {label}
        </button>
    );
};

export default LanguageSwitcherComponent;
